import { useEffect, useState, useRef } from "react";
import "@/App.css";

const REDIRECT_URL = "https://datenow.link/link/3116/99880361";

const STEPS = [
  {
    title: "Suchen Sie jemanden in Ihrer Nähe?",
    subtitle: "Viele Singles aus Ihrer Region sind gerade online und auf der Suche.",
    options: [
      { emoji: "❤️", label: "Ja, ich suche ein Treffen", desc: "Ich möchte neue Menschen kennenlernen", value: "meeting" },
      { emoji: "👀", label: "Ich schaue mich nur um", desc: "Erst einmal ohne Verpflichtung", value: "browsing" },
    ],
  },
  {
    title: "Wie alt sind Sie?",
    subtitle: "Wir passen die Auswahl perfekt an Ihre Altersgruppe an.",
    options: [
      { emoji: "🎓", label: "Unter 45 Jahren", desc: "Jung, dynamisch, neugierig", value: "under45" },
      { emoji: "🍷", label: "45 Jahre oder älter", desc: "Reif, erfahren, selbstbewusst", value: "over45" },
    ],
  },
  {
    title: "Wen möchten Sie kennenlernen?",
    subtitle: "Damit wir Ihnen passende Profile zeigen können.",
    options: [
      { emoji: "👱‍♀️", label: "Frauen", desc: "", value: "women" },
      { emoji: "👱‍♂️", label: "Männer", desc: "", value: "men" },
      { emoji: "👥", label: "Beides", desc: "", value: "both" },
    ],
  },
  {
    title: "Was suchen Sie genau?",
    subtitle: "Letzte Frage — dann zeigen wir Ihnen passende Singles.",
    options: [
      { emoji: "💍", label: "Feste Beziehung", desc: "Etwas Dauerhaftes aufbauen", value: "serious" },
      { emoji: "💬", label: "Lockerer Flirt", desc: "Spontan und ungezwungen", value: "casual" },
      { emoji: "✨", label: "Ich bin offen für alles", desc: "Überraschen Sie mich", value: "open" },
    ],
  },
];

const LOADING_MESSAGES = [
  "Alterspräferenz wird analysiert...",
  "Profile in Ihrer Region werden gefiltert...",
  "Kompatibilitätswerte werden berechnet...",
  "Beste Übereinstimmungen werden sortiert...",
  "Fast fertig...",
];

function OnlineCounter() {
  const [count, setCount] = useState(() => 40 + Math.floor(Math.random() * 11));
  useEffect(() => {
    const id = setInterval(() => {
      setCount((c) => {
        const delta = Math.random() < 0.5 ? -1 : 1;
        let next = c + delta;
        if (next < 40) next = 41;
        if (next > 50) next = 49;
        return next;
      });
    }, 5000);
    return () => clearInterval(id);
  }, []);
  return (
    <div
      data-testid="online-counter"
      className="flex items-center gap-2 rounded-full bg-white/90 backdrop-blur-md px-3 py-1.5 shadow-[0_2px_12px_rgba(236,72,153,0.12)] border border-pink-100"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
      </span>
      <span className="font-bold text-slate-900 tabular-nums" data-testid="online-count-value">{count}</span>
      <span className="text-slate-500 text-sm">online</span>
    </div>
  );
}

function Logo() {
  return (
    <div className="flex items-center gap-3" data-testid="site-logo">
      <div className="relative w-11 h-11 sm:w-12 sm:h-12 rounded-2xl flex items-center justify-center shadow-[0_8px_24px_-8px_rgba(217,70,239,0.55)] overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, #ec4899 0%, #a855f7 55%, #6d28d9 100%)",
          }}
        />
        <svg viewBox="0 0 24 24" className="relative w-6 h-6 sm:w-7 sm:h-7" fill="none">
          <path
            d="M12 21s-7-4.5-9.5-9C.8 8.5 3 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 4 0 6.2 4.5 4.5 8-2.5 4.5-9.5 9-9.5 9z"
            fill="#fff"
          />
          <path
            d="M16.5 4.5l.8 1.7 1.7.8-1.7.8-.8 1.7-.8-1.7-1.7-.8 1.7-.8.8-1.7z"
            fill="#fde68a"
          />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <h1 className="text-xl sm:text-2xl font-black tracking-tight text-slate-900" data-testid="brand-name">
          Frümmerliebe<span className="bg-gradient-to-r from-fuchsia-500 to-violet-500 bg-clip-text text-transparent">.de</span>
        </h1>
        <span className="hidden sm:inline-block text-[10px] uppercase tracking-[0.22em] text-fuchsia-500/70 mt-1">
          Echte Begegnungen
        </span>
      </div>
    </div>
  );
}

function ProgressDots({ current, total }) {
  return (
    <div className="flex items-center justify-center gap-3 mb-6" data-testid="progress-dots">
      {Array.from({ length: total }).map((_, i) => {
        const isDone = i < current;
        const isCurrent = i === current;
        return (
          <div
            key={i}
            className={`transition-all duration-300 flex items-center justify-center rounded-full ${
              isCurrent
                ? "w-4 h-4 bg-fuchsia-500 shadow-[0_0_0_5px_rgba(217,70,239,0.15)]"
                : isDone
                ? "w-4 h-4 bg-violet-400"
                : "w-3 h-3 bg-pink-200"
            }`}
          >
            {isDone && (
              <svg viewBox="0 0 24 24" className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" strokeWidth="4">
                <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </div>
        );
      })}
    </div>
  );
}

function QuestionCard({ step, stepIndex, total, onSelect, onBack }) {
  return (
    <div
      className="relative bg-white rounded-3xl shadow-[0_30px_80px_-25px_rgba(217,70,239,0.25)] border border-pink-100 overflow-hidden"
      data-testid={`question-card-${stepIndex}`}
    >
      <div className="h-1.5 bg-gradient-to-r from-fuchsia-500 via-pink-500 to-violet-500" />
      <div className="px-6 sm:px-12 py-10 sm:py-14">
        <ProgressDots current={stepIndex} total={total} />
        <div className="flex justify-center mb-6">
          <span className="inline-block bg-fuchsia-50 text-fuchsia-600 text-xs font-bold tracking-[0.18em] px-4 py-1.5 rounded-full border border-fuchsia-100">
            SCHRITT {stepIndex + 1} VON {total}
          </span>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-slate-900 tracking-tight leading-tight">
          {step.title}
        </h2>
        <p className="text-center text-slate-500 mt-4 text-base sm:text-lg max-w-xl mx-auto">{step.subtitle}</p>

        <div className="mt-10 space-y-3 max-w-2xl mx-auto">
          {step.options.map((opt, i) => (
            <button
              key={opt.value}
              onClick={() => onSelect(opt.value)}
              data-testid={`option-${stepIndex}-${opt.value}`}
              className="group w-full flex items-center gap-4 sm:gap-5 p-4 sm:p-5 rounded-2xl border-2 border-pink-100 bg-white hover:border-fuchsia-400 hover:bg-pink-50/50 hover:-translate-y-0.5 transition-all duration-200 text-left shadow-sm hover:shadow-[0_10px_30px_-10px_rgba(217,70,239,0.25)]"
            >
              <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-pink-100 via-fuchsia-50 to-violet-100 flex items-center justify-center text-2xl sm:text-3xl">
                <span>{opt.emoji}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-slate-900 text-base sm:text-lg">{opt.label}</div>
                {opt.desc && <div className="text-slate-500 text-sm sm:text-base mt-0.5">{opt.desc}</div>}
              </div>
              <div className="flex-shrink-0 w-6 h-6 rounded-full border-2 border-pink-200 group-hover:border-fuchsia-500 transition-colors" />
            </button>
          ))}
        </div>

        {stepIndex > 0 && (
          <div className="mt-8 flex justify-center">
            <button
              onClick={onBack}
              data-testid="back-button"
              className="text-slate-500 hover:text-fuchsia-600 transition-colors text-base font-medium"
            >
              ← Zurück
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function LoadingCard({ total }) {
  const [progress, setProgress] = useState(0);
  const [msgIndex, setMsgIndex] = useState(0);
  const DURATION = 6000;

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, (elapsed / DURATION) * 100);
      setProgress(pct);
      const idx = Math.min(
        LOADING_MESSAGES.length - 1,
        Math.floor((elapsed / DURATION) * LOADING_MESSAGES.length)
      );
      setMsgIndex(idx);
      if (elapsed >= DURATION) clearInterval(id);
    }, 60);

    const redirectTimer = setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, DURATION);

    return () => {
      clearInterval(id);
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <div
      className="relative bg-white rounded-3xl shadow-[0_30px_80px_-25px_rgba(217,70,239,0.25)] border border-pink-100 overflow-hidden"
      data-testid="loading-card"
    >
      <div className="h-1.5 bg-gradient-to-r from-fuchsia-500 via-pink-500 to-violet-500" />
      <div className="px-6 sm:px-12 py-14 sm:py-20">
        <ProgressDots current={total} total={total} />

        <div className="flex justify-center mb-8 mt-4">
          <div className="relative w-24 h-24">
            <svg className="w-24 h-24 -rotate-90" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="42" fill="none" stroke="#fce7f3" strokeWidth="6" />
              <circle
                cx="50"
                cy="50"
                r="42"
                fill="none"
                stroke="url(#loaderGrad)"
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray="264"
                strokeDashoffset="80"
                className="animate-spin origin-center"
                style={{ animationDuration: "1.4s" }}
              />
              <defs>
                <linearGradient id="loaderGrad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#ec4899" />
                  <stop offset="100%" stopColor="#a855f7" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-slate-900 tracking-tight">
          Ihre Matches werden gesucht…
        </h2>
        <p className="text-center text-slate-500 mt-4 text-base sm:text-lg">
          Wir analysieren Tausende Profile in Ihrer Nähe.
        </p>

        <div className="mt-10 max-w-xl mx-auto">
          <div className="h-2.5 rounded-full bg-pink-100 overflow-hidden" data-testid="loading-progress-bar">
            <div
              className="h-full bg-gradient-to-r from-fuchsia-500 via-pink-500 to-violet-500 transition-all duration-100 ease-linear"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p
            className="text-center text-slate-500 italic mt-6 text-sm sm:text-base"
            data-testid="loading-message"
            key={msgIndex}
          >
            {LOADING_MESSAGES[msgIndex]}
          </p>
        </div>
      </div>
    </div>
  );
}

function HowItWorks() {
  const steps = [
    { num: 1, title: "Quiz beantworten", desc: "4 kurze Fragen zu Ihren Wünschen und Ihrem Alter." },
    { num: 2, title: "Matches finden", desc: "Unsere Auswahl sucht passende Singles in Ihrer Stadt." },
    { num: 3, title: "Kostenlos registrieren", desc: "Legen Sie ein kostenloses Profil beim Partnerportal an." },
  ];
  return (
    <section className="mt-20 sm:mt-28" data-testid="how-it-works">
      <h3 className="text-center text-2xl sm:text-3xl font-black text-slate-900 mb-10">So funktioniert es</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-7">
        {steps.map((s) => (
          <div
            key={s.num}
            className="bg-white rounded-2xl p-8 text-center shadow-[0_8px_30px_-12px_rgba(217,70,239,0.18)] border border-pink-100 hover:-translate-y-1 hover:border-fuchsia-300 transition-all duration-300"
            data-testid={`how-step-${s.num}`}
          >
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-fuchsia-500 to-violet-500 text-white font-black text-lg flex items-center justify-center mx-auto mb-5 shadow-[0_8px_20px_-6px_rgba(217,70,239,0.5)]">
              {s.num}
            </div>
            <h4 className="font-bold text-slate-900 text-lg mb-3">{s.title}</h4>
            <p className="text-slate-500 text-sm sm:text-base leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function Pills() {
  const pills = ["Kostenlos & diskret", "Nur 4 Fragen", "Ab 18 Jahren"];
  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-3 sm:gap-5" data-testid="trust-pills">
      {pills.map((p, i) => (
        <span
          key={p}
          className="inline-flex items-center gap-2 bg-white/80 backdrop-blur px-5 py-2 rounded-full text-slate-600 text-sm sm:text-base border border-pink-100"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-fuchsia-500" />
          {p}
        </span>
      ))}
    </div>
  );
}

export default function App() {
  const [stepIndex, setStepIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const total = STEPS.length;
  const containerRef = useRef(null);

  const handleSelect = (value) => {
    const key = `q${stepIndex + 1}`;
    setAnswers((a) => ({ ...a, [key]: value }));
    if (stepIndex + 1 < total) {
      setStepIndex(stepIndex + 1);
    } else {
      setLoading(true);
    }
  };

  const handleBack = () => {
    if (stepIndex > 0) setStepIndex(stepIndex - 1);
  };

  return (
    <div
      className="min-h-screen w-full font-body relative overflow-hidden text-slate-900"
      style={{
        background:
          "linear-gradient(135deg, #fff1f5 0%, #fde7f3 40%, #f5ebff 100%)",
      }}
      data-testid="app-root"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.55]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 12% 8%, rgba(236,72,153,0.18), transparent 40%), radial-gradient(circle at 88% 78%, rgba(168,85,247,0.18), transparent 42%), radial-gradient(circle at 60% 50%, rgba(244,114,182,0.10), transparent 55%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 pt-6 sm:pt-8 pb-16">
        <header className="flex items-center justify-between gap-3 mb-8 sm:mb-10" data-testid="header">
          <Logo />
          <div className="flex items-center gap-2 sm:gap-3">
            <span
              className="hidden sm:inline-flex items-center bg-white/85 backdrop-blur border border-fuchsia-200 text-fuchsia-600 text-xs font-bold tracking-[0.18em] px-4 py-1.5 rounded-full"
              data-testid="age-badge"
            >
              AB 18 JAHREN
            </span>
            <OnlineCounter />
          </div>
        </header>

        <main ref={containerRef}>
          {!loading ? (
            <QuestionCard
              step={STEPS[stepIndex]}
              stepIndex={stepIndex}
              total={total}
              onSelect={handleSelect}
              onBack={handleBack}
            />
          ) : (
            <LoadingCard total={total} />
          )}

          <Pills />
          <HowItWorks />
        </main>

        <footer className="mt-20 pt-8 border-t border-pink-100 text-center" data-testid="footer">
          <p className="text-slate-500 text-sm">© 2024 Frümmerliebe.de · Alle Rechte vorbehalten.</p>
          <p className="text-fuchsia-600 font-bold text-sm mt-2">Nur für Personen ab 18 Jahren.</p>
        </footer>
      </div>
    </div>
  );
}
